import {AbstractModel, JsonObject, JsonProperty} from '../../../../../../core/src/public-api';
import {ShortProject} from '../../project-misc/data/project/short-project';
import {ShortObject} from '../../project-misc/data/project/short-json-object';

@JsonObject('model.pricingFilters')
export class PricingFilters extends AbstractModel {

  @JsonProperty([ShortProject], 'projects')
  projects: ShortProject[];

  @JsonProperty([ShortProject], 'users')
  users: ShortProject[];

  @JsonProperty([ShortObject], 'customers')
  customers: ShortObject[];

  @JsonProperty([ShortObject], 'statuses')
  statuses: ShortObject[];
}
